import * as React from 'react';
import { useState, useEffect } from 'react';
import { View, Icon, Text, Button } from 'native-base';
import { StyleSheet, TouchableOpacity } from 'react-native';
import CalCalDataApi from '../../api/CalCalDataApi';
import { isArray } from 'lodash';
import { useDispatch } from 'react-redux';
import { deleteTrans } from '../DailyEntries/actions';

export default function TransactionAdder({ item, navigation, jwt, updateItem }) {
	const zero = '0.00';
	const amountString = Math.abs(item.amount).toFixed(2);
	const isIn = item.amount > 0;

	//const category = categories.find(cat => cat.id == item.categoryId);

	const [buttons, setButtons] = useState();

	useEffect(() => {
		__DEV__ && console.log(item);
		CalCalDataApi.dataLoad('bankimport/transaction/' + item.id, jwt, res => {
			if (res.success) {
				//also have res.transaction

				setButtons(res.buttons);
			}
		});
	}, [item]);

	useEffect(() => {
		const unsubscribe = navigation.addListener('focus', () => {
			CalCalDataApi.dataLoad('bankimport/transaction/' + item.id, jwt, res => {
				if (res.success) {
					updateItem({ id: item.id, de_id: res.transaction.de_id });
				}
			});
		});

		return unsubscribe;
	}, [navigation]);

	const buttonFunction = (func, args) => {
		const theFunction = func == 'receipt' ? _addReceipt : func == 'expense' ? _addExpense : func == 'transaction' ? matchTransaction : _addTransfer;
		theFunction(isArray(args) ? [...args] : [args]);
	};

	const _addReceipt = ([customer_id = null, takingCategory_id = 0]) => {
		//if customer, put as payment only
		/*if (customer_id)
			return navigation.navigate('Entry', {
				addTrans: 'receipt',
				customer_id: customer_id,
				addDate: new Date(item.date).toISOString().split('T')[0],
				paymentOnly: true
			});*/
		//console.log(this.selDay.dateString);
		navigation.navigate('Entry', {
			addTrans: 'receipt',
			paymentOnly: !!customer_id,
			entry: {
				expenseDate: new Date(item.date).toISOString().split('T')[0],
				account_id: item.accountCalcalId,
				net: amountString,
				payable: amountString,
				paid: amountString,
				vat: zero,
				takingCategory_id: Number(takingCategory_id),

				description: item.description || item.name,
				setransaction_id: item.id,
				customer_id
			}
		});
	};

	const _addExpense = ([expenseCategory_id = 0, supplier_id = null]) => {
		navigation.navigate('Entry', {
			addTrans: 'expense',
			paymentOnly: !!supplier_id,
			entry: {
				expenseDate: new Date(item.date).toISOString().split('T')[0],
				account_id: item.accountCalcalId,
				net: amountString,
				payable: amountString,
				paid: amountString,
				vat: zero,
				expenseCategory_id: Number(expenseCategory_id),
				description: item.description || item.name,
				setransaction_id: item.id,
				supplier_id
			}
		});
	};

	const _addTransfer = ([otherAcct = null]) => {
		__DEV__ && console.log(otherAcct, arguments);
		navigation.navigate('Entry', {
			addTrans: 'transfer',
			entry: {
				transferDate: new Date(item.date).toISOString().split('T')[0],
				fromAcct_id: isIn ? otherAcct : item.accountCalcalId,
				toAcct_id: isIn ? item.accountCalcalId : otherAcct,
				description: item.description || item.name,
				setransaction_id: item.id,
				amount: amountString
			}
		});
	};

	const matchTransaction = ([type, tid]) => {
		//just do this.
		CalCalDataApi.dataUpdate('bankimport/transaction/' + item.id, { type, id: tid }, jwt, res => {
			if (res.success) {
				//do some nice animation; update item
				updateItem({ id: item.id, de_id: res.id || tid + (type == 'expense' ? '2' : type == 'taking' ? '1' : '3'), importedIcon: 'ios-checkmark-circle-outline' });
			}
		});
	};

	const dispatch = useDispatch();

	const deleteTransaction = () => {
		const type = item.de_id.substr(-1);
		const transaction_type = type == 1 ? 'receipt' : type == 2 ? 'expense' : 'transfer';
		const real_id = item.de_id.substr(0, item.de_id.length - 1);
		dispatch(deleteTrans({ transaction_type, real_id, expenseDate: new Date(item.date).toISOString().split('T')[0] }, false));
		updateItem({ id: item.id, de_id: null });
	};

	//type: INCOME, EXPENSES, TRANSFERS

	//make some values that could be replaced by the API call (which will take a second)
	var mainFunc;
	if (item.categoryType == 'INCOME') {
		if (!buttons)
			setButtons([
				{
					button: 'TRANSFER',
					func: _addTransfer,
					others: []
				},
				{
					button: 'INCOME',
					func: _addReceipt,
					others: []
				},
				{
					button: 'CUSTOMER',
					func: _addReceipt,
					others: []
				}
			]);
	} else if (item.categoryType == 'EXPENSES') {
		if (!buttons)
			setButtons([
				{
					button: 'TRANSFER',
					func: _addTransfer,
					others: []
				},
				{
					button: 'EXPENSE',
					func: _addExpense,
					others: []
				},
				{
					button: '',
					func: '',
					others: []
				}
			]);
	} else {
		if (!buttons)
			setButtons([
				{ button: isIn ? 'INCOME' : 'EXPENSE', func: isIn ? _addReceipt : _addExpense, others: [] },
				{ button: 'TRANSFER', func: _addTransfer, others: [] },
				{ button: '', funct: '', others: [] }
			]);
	}

	if (!buttons) return null;
	//console.log(buttons);
	return (
		<View style={{ flex: 1, flexDirection: 'row', justifyContent: !!item.de_id ? 'space-evenly' : 'space-between', backgroundColor: '#b4d0e0' }}>
			{!item.de_id &&
				buttons.map((button, i) => (
					<View key={i} style={{ flex: 1, flexDirection: 'column', alignItems: 'center', transform: [{ scale: !button.default ? 0.8 : 1 }] }}>
						<TouchableOpacity onPress={() => button.func && buttonFunction(button.func, button.others[0]?.args)}>
							<Text style={styles.subButton} numberOfLines={1}>
								{button.others[0]?.display}
							</Text>
						</TouchableOpacity>
						<TouchableOpacity onPress={() => button.func && buttonFunction(button.func, button?.args)}>
							<Text style={styles.mainButton}>{button.button}</Text>
						</TouchableOpacity>
						<TouchableOpacity onPress={() => button.func && buttonFunction(button.func, button.others[1]?.args)}>
							<Text style={styles.subButton} numberOfLines={1}>
								{button.others[1]?.display}
							</Text>
						</TouchableOpacity>
					</View>
				))}

			{!item.de_id && (
				<TouchableOpacity style={{ flexDirection: 'column', alignItems: 'center', margin: 5, marginRight: 15 }} onPress={() => matchTransaction([null, 0])}>
					<Text style={{ fontSize: 11, color: '#6b1010' }}>Non-</Text>
					<Icon style={{ fontSize: 22, color: '#A11', fontWeight: 'bold' }} name="ios-remove-circle-outline" />
					<Text style={{ fontSize: 11, color: '#6b1010' }}>business</Text>
				</TouchableOpacity>
			)}
			{!!item.de_id && (
				<>
					<Button transparent primary iconLeft>
						<Icon name="ios-checkmark-circle-outline" />
						<Text>Transaction imported</Text>
					</Button>
					<Button bordered danger onPress={deleteTransaction}>
						<Text>Undo</Text>
					</Button>
				</>
			)}
		</View>
	);
}

const styles = StyleSheet.create({
	subButton: {
		fontWeight: '200',
		color: '#444',
		fontSize: 13
	},
	mainButton: { fontWeight: '600', color: '#0d3b6f' }
});
